// @core/api/endpoints/document/get_pipeline_execution.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineExecutionResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Get pipeline execution
 * Returns pipeline execution with all stage and actor execution details.
 */
export async function GetPipelineExecution(
  target_type: string,
  target_id: string,
  execution_id: string,
  options?: RequestOptions
): Promise<PipelineExecutionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/pipeline-executions/:execution_id`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  requestPath = requestPath.replace(':execution_id', encodeURIComponent(execution_id));
  const requestOptions = options;
  return client.get<PipelineExecutionResponse>(requestPath, { ...requestOptions });
}
